<div id="installer-log-list-component" class="component-inner-wrapper">
  <main class="main-content">
    <div class="container">

<div class="aggrid-criteria">
        <div class="grid-filter-criteria filter-row">
          <div>
            <label class="col-form-label me-2">File Name</label>
            <input type="text" class="form-control custom-input mb-2" placeholder=""
              [(ngModel)]="fileNameFilter" (input)="onFilterChange()">
          </div>
          <div class="loading-indicator" *ngIf="isLoading || isContentLoading">
            <span class="spinner-border spinner-border-sm" role="status"></span>
            <span class="ms-2">{{ isContentLoading ? 'Loading log…' : 'Loading…' }}</span>
          </div>
        </div>
      </div>

      <div class="content-wrapper content-wrapper-aggrid">
        <div class="component-ag-grid-wrapper" (contextmenu)="preventDefaultContextMenu($event)"
          mcAgGridCopyCellTooltip style="position: relative;">
          <ag-grid-angular
            class="ag-theme-alpine"
            [rowModelType]="'infinite'"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [pagination]="true"
            [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="pageSizeOptions"
            [datasource]="dataSource"
            (gridReady)="onGridReady($event)"
            [cacheBlockSize]="paginationPageSize"
            [maxBlocksInCache]="1"
            (paginationChanged)="onPaginationChanged($event)"
            (cellContextMenu)="onCellContextMenu($event)"
          >
          </ag-grid-angular>
          <div class="custom-context-menu"
            [ngStyle]="{'top.px': contextMenuPosition.y, 'left.px': contextMenuPosition.x}"
            *ngIf="contextMenuVisible">
            <ul>
              <li (click)="handleCopy()">Copy Value</li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </main>
</div>
